import { getDataFromStores } from '../../../../shared/utils';
import store from '../store';

export const getStoredData = () =>
    getDataFromStores(
        store.user,
        store.brief,
        store.referrer,
        store.pagePath,
        store.userActivated,
        store.sellerId,
        store.projectId,
        store.variationId,
        store.numberOfVariations,
        store.edited,
        store.package,
        store.navigationSource,
        store.offerDisplayed,
        store.sellerCardDisplayed,
        store.numberOfSelectedProjects,
        store.selectedProjects
    );
